import DOMPurify from 'dompurify';

/**
 * CWE-79: Sanitize user-supplied HTML descriptions before rendering with dangerouslySetInnerHTML.
 *
 * Allows only safe formatting tags used in video descriptions (paragraphs, links,
 * lists, inline formatting) and strips everything else — including <img>, <script>,
 * <iframe>, <svg>, and any event-handler attributes (onerror, onclick, etc.).
 *
 * @see HackerOne #3526065 — stored XSS via video description
 */

const ALLOWED_TAGS = [
  'p',
  'br',
  'a',
  'b',
  'i',
  'em',
  'strong',
  'u',
  'ul',
  'ol',
  'li',
  'span',
  'blockquote',
  'pre',
  'code',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'hr',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'data-time'];

export function sanitizeDescriptionHtml(html: string): string {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}
